import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { states } from "./states.data";
import { StateModel } from "../../models/state.model";

@Injectable()
export class StateService {
  constructor() {}

  get(): Observable<Array<StateModel>> {
    return new Observable(observer => {
      observer.next(states);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/state/state.service.ts